module.exports = __webpack_public_path__ + "static/media/so.f91fb92c.svg";